import { useQueryClient } from '@tanstack/react-query';

import { getRecommendedPlayersKey } from './getRecommendedPlayers.options';

export const useInvalidateRecommendedPlayers = () => {
  const client = useQueryClient();
  return () =>
    client.invalidateQueries({ queryKey: getRecommendedPlayersKey() });
};
